<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createAcademiaUsuario"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAcademyInvitationsModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomSelectPrimary
          v-model.number="registracion.actor"
          :elements="tipoActores"
          :inputError="$v.registracion.actor.$error"
          keyField="id"
          :label="$t('mEditionAcademyInvitationsModalCreate.inputs.actor.label')"
          :messageError="messageErrorActor"
          name="actor"
          textField="name"
          @blur="$v.registracion.actor.$touch()"
        />
        <AtomInputPrimary
          v-model="registracion.email"
          :inputError="$v.registracion.email.$error"
          :label="$t('mEditionAcademyInvitationsModalCreate.inputs.email.label')"
          :messageError="messageErrorEmail"
          name="email"
          :placeholder="$t('mEditionAcademyInvitationsModalCreate.inputs.email.placeholder')"
          type="text"
          @blur="$v.registracion.email.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAcademyInvitationsModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { email, required, integer } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAcademyInvitationsModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAcademyInvitationsModalCreate.buttonPrimary'),
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      },

      registracion: {
        actor: '',
        email: ''
      }
    }
  },

  validations: {
    registracion: {
      actor: {
        required,
        integer
      },

      email: {
        email,
        required
      },

      tipoActores: []
    }
  },

  computed: {
    messageErrorActor () {
      return this.$validation.getValidationMessage('mEditionAcademyUsersModalCreate', this.$v.registracion.actor, 'actor')
    },

    messageErrorEmail () {
      return this.$validation.getValidationMessage('mEditionAcademyUsersModalCreate', this.$v.registracion.email, 'email')
    }
  },

  watch: {
    'registracion.email' () {
      this.registracion.email = this.registracion.email.toLowerCase()
    }
  },

  created () {
    this.tipoActores = [...this.$filters.parameters.actors]
    this.tipoActores.shift()
  },

  methods: {
    createAcademiaUsuario () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'createAcademiaUsuario', this.registracion, [this.$store.getters.getAcademyData.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readAcademiaRecursosUsados () {
      if (this.registracion.actor === 0) {
        this.$license.readAcademiaRecursosUsados()
      }
    }
  }
}
</script>
